<template>
    <!-- http://designsystem.morningstar.com/components/loaders.html -->
    <div class="mds-loader" :class="sizeClass" role="progressbar" aria-valuetext="Please wait, content is loading...">
        <div class="mds-loader__item mds-loader__item--1"></div>
        <div class="mds-loader__item mds-loader__item--2"></div>
        <div class="mds-loader__item mds-loader__item--3"></div>
        <div class="mds-loader__item mds-loader__item--4"></div>
        <div class="mds-loader__item mds-loader__item--5"></div>
        <div class="mds-loader__item mds-loader__item--6"></div>
        <div class="mds-loader__item mds-loader__item--7"></div>
        <div class="mds-loader__item mds-loader__item--8"></div>
    </div>
</template>

<script>
    export default {
        name: "loading-spinner",
        props: {
            size: {
                type: Number,
                default: 1
            }
        },
        computed: {
            sizeClass () {
                switch (this.size) {
                case 0: return "mds-loader--small";
                case 2: return "mds-loader--large";
                default: return "";
                }
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/LoadingSpinner.vue